import {Cookie} from '@helpers/cookie'
import {getParams} from '@helpers/url'

export class Debug {

  static _isDebug: boolean;

  static init() {
    Debug._isDebug = Cookie.read('d') === '1'
    const debugParam = getParams('d')
    if (debugParam) {
      Cookie.write('d', debugParam)
    }
    Debug._isDebug = Cookie.read('d') === '1'
  }

  static isDebugMode(): boolean {
    return Debug._isDebug
  }

}
